import { render } from "./TextAreaField.vue?vue&type=template&id=6d6efcab"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"
script.render = render

export default script